module.exports = __webpack_public_path__ + "img/mira_970m_list.e9677aab.jpg";